export default () => {
  localStorage.setItem('lastInteractionTime', new Date());
};
